import {ReportGroupingLevel} from '../../../constants'
import CSVPreviewCostProfitLossAdditionalSection from '../CSVPreviewCostProfitLossAdditionalSection'
import CSVPreviewEmptySection from '../CSVPreviewEmptySection'
import CSVParametersBuilder from '../CSVParametersBuilder'
import ProfitLossCSVPreviewHeader from './ProfitLossCSVPreviewHeader'
import ProfitLossCSVPreviewGroupingSection from './ProfitLossCSVPreviewGroupingSection'
import CSVParametersSection from '../CSVParametersSection'

export default function ProfitLossCSVPreviewGenerator() {}

ProfitLossCSVPreviewGenerator.prototype.init = function(){
    return this;
};

ProfitLossCSVPreviewGenerator.prototype.BASE_COUNT_DATA_COLUMNS = 3;

ProfitLossCSVPreviewGenerator.prototype.generatePreviewTable = function( reportParameters, reportParamsStringBuilder) {

    var numOfGroupingColumns = ReportPreviewUtils.countNotEmptyLevels( [
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel
    ] );

    if(reportParameters.thirdGroupingLevel != ReportGroupingLevel.NONE){
        numOfGroupingColumns++;
    }
    var countDataColumns = this.BASE_COUNT_DATA_COLUMNS;

    if(reportParameters.showSpentTime){
        countDataColumns++;
    }

    if(reportParameters.showAverageRates){
        countDataColumns+=2;
    }

    var totalColumnsNum = countDataColumns + numOfGroupingColumns;

    var header = new ProfitLossCSVPreviewHeader().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        reportParameters.showSpentTime,
        reportParameters.showAverageRates
    );

    var dataGroupingSection = new ProfitLossCSVPreviewGroupingSection().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        countDataColumns,
        numOfGroupingColumns
    );

    var additionalSection = new CSVPreviewCostProfitLossAdditionalSection().init(
            countDataColumns,
            numOfGroupingColumns,
            reportParameters.showOvertimeAddition,
            reportParameters.showLeaveTimeCosts
    );
    var emptySection = new CSVPreviewEmptySection().init(1, totalColumnsNum);

    var table = document.createElement( "table" );
    table.className = "reportCsvPreviewTable profitLoss";
    var tBody = document.createElement( "tbody" );
    table.appendChild( tBody );
    var totalRowNum = 15;

    ReportPreviewUtils.addSheetHeaderRow( tBody, totalColumnsNum );

    var paramsBuilder = new CSVParametersBuilder().init();
    paramsBuilder.addDateRangeParam( reportParameters.dateRangeSelection, reportParamsStringBuilder );
    paramsBuilder.addCPParam( reportParameters.customersProjectsSelection, reportParamsStringBuilder );

    var parametersSection = new CSVParametersSection().init( paramsBuilder, totalColumnsNum );

    parametersSection.addRows( tBody );
    header.addRows( tBody );
    dataGroupingSection.addRows( tBody );
    emptySection.addRows(tBody);
    additionalSection.addRows(tBody);
    this.addEmptySectionIfNeeded(totalRowNum, tBody, totalColumnsNum)

    return table;
};

ProfitLossCSVPreviewGenerator.prototype.addEmptySectionIfNeeded = function ( totalRowsNum, tBody, totalColumnsNum )
{
    var numOfEmptyRows = totalRowsNum + 1 - tBody.childNodes.length;
    if ( numOfEmptyRows > 0 )
        new CSVPreviewEmptySection().init( numOfEmptyRows, totalColumnsNum ).addRows( tBody );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/profitloss/ProfitLossCSVPreviewGenerator.js